/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React from "react"
import EmployeeOnlyModalContainer from "../../employee-only-containers/EmployeeOnlyModalContainer"
import {
  Box,
  Button,
  CloseIcon,
  Dialog,
  DialogContentText,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  useTheme
} from "@carrotfertility/carotene-core"
import { FormattedMessage, useIntl } from "react-intl"

export const UpdateYourContactModal = ({ onExit }) => {
  const theme = useTheme()
  const intl = useIntl()

  return (
    <EmployeeOnlyModalContainer onClose={onExit}>
      <Dialog open onClose={onExit}>
        <DialogTitle>
          <Box display="flex" justifyContent="flex-end">
            <IconButton aria-label={intl.formatMessage({ defaultMessage: "Close" })} onClick={onExit}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContentText variant="h3" component="h1" marginBottom={(theme) => theme.spacing(theme.tokens.spacing.md)}>
          <FormattedMessage defaultMessage="Update your contact information" />
        </DialogContentText>
        <Stack spacing={theme.spacing(theme.tokens.spacing.lg)} divider={<Divider />}>
          <DialogContentText>
            <FormattedMessage defaultMessage="To add a preferred contact email or a partner's email visit your Account Settings." />
          </DialogContentText>
          <Box>
            <Button onClick={() => (window.location.href = "/account#Personal information")}>
              <FormattedMessage defaultMessage="Update now" />
            </Button>
          </Box>
        </Stack>
      </Dialog>
    </EmployeeOnlyModalContainer>
  )
}
